var React = require('react');

function Planet (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E7E5E4","d":"M14 2.625C7.728 2.625 2.625 7.728 2.625 14S7.728 25.375 14 25.375 25.375 20.272 25.375 14 20.272 2.625 14 2.625Zm0 1.75c.296 0 .586.018.875.044v1.706h-1.75L12.25 8.75h-.875v.875h4.375l.875.875h.875v.875l-.875.875-3.5-.875L9.625 14v2.625l1.75 1.75H14v2.188l.875 2.187h.875l2.625-3.5v-.875l.875-1.75v-.875h-.875L17.5 14l.875-.875 1.313.875 2.187-.875v-.875h1.583c.105.569.167 1.152.167 1.75 0 5.307-4.318 9.625-9.625 9.625S4.375 19.307 4.375 14 8.693 4.375 14 4.375Z"}));
}

Planet.defaultProps = {"fill":"none","viewBox":"0 0 28 28"};

module.exports = Planet;

Planet.default = Planet;
